import { render, staticRenderFns } from "./Quarter.vue?vue&type=template&id=bb0ecdce&scoped=true&"
import script from "./Quarter.vue?vue&type=script&lang=js&"
export * from "./Quarter.vue?vue&type=script&lang=js&"
import style0 from "./Quarter.vue?vue&type=style&index=0&id=bb0ecdce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0ecdce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb0ecdce')) {
      api.createRecord('bb0ecdce', component.options)
    } else {
      api.reload('bb0ecdce', component.options)
    }
    module.hot.accept("./Quarter.vue?vue&type=template&id=bb0ecdce&scoped=true&", function () {
      api.rerender('bb0ecdce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/Quarter.vue"
export default component.exports